export const TodoType = {
    task : 0,
    project : 1
}
